import { createSelector } from 'reselect';
import { getScoreData } from 'utils/data';
const getCompareCountries = (state) => state.compare.filters.countries;
const getData = (state) => state.compare.data;
export const getCountriesData = createSelector(
  [getCompareCountries, getData],
  (countries, data) => {
    const compare = {};
    Object.keys(countries).forEach((country) => {
      if (countries[country]) {
        compare[country] = data[countries[country]] || false;
      }
    });
    return compare;
  }
);

const getOverview = (state) => state.overview;
export const parseOverviewData = createSelector(
  [getOverview, getCompareCountries, getData],
  (overviewData, countries, data) => {
    if (!overviewData.length) return { overview: [], legend: [] };

    const overview = overviewData.map((item) => ({
      name: item.name,
      avg: item.avg,
      values: []
    }));
    const legend = [];
    Object.keys(countries).forEach((country) => {
      const countryData = data[countries[country]] || false;
      if (countryData && !countryData.error) {
        countryData.overview.forEach((o, index) => {
          overview[index].values.push({
            country,
            value: o
          });
        });
        legend.push({
          country,
          value: countryData.country
        });
      }
    });
    legend.push({ value: 'Average score' });
    return { overview, legend };
  }
);

const getReport = (state) => state.report;
export const parseDataReport = createSelector(
  [getReport, getCompareCountries, getData],
  (reportData, countries, data) => {
    if (!reportData.length) return [];
    const parseQuestions = (questions) => (
      questions.map((q) => {
        q.values = [];  // eslint-disable-line no-param-reassign
        Object.keys(countries).forEach(function (country) { // eslint-disable-line prefer-arrow-callback
          const countryData = data[countries[country]] || false;
          if (countryData && !countryData.error) {
            const answerData = countryData.answers[q.slug] || false;
            if (answerData) {
              q.values.push({ country, value: answerData });
            } else {
              q.values.push({ country, value: '-' });
            }
          } else {
            q.values.push({ country, value: '-' });
          }
        });
        return q;
      })
    );

    function parseReport(reportSection) {
      for (let i = 0, rLength = reportSection.length; i < rLength; i++) {
        reportSection[i].values = [];  // eslint-disable-line no-param-reassign
        Object.keys(countries).forEach(function (country) { // eslint-disable-line prefer-arrow-callback, no-loop-func
          const countryData = data[countries[country]] || false;
          if (countryData && !countryData.error) {
            const answerData = countryData.scores[reportSection[i].slug] || false;
            if (answerData) {
              reportSection[i].values.push({ country, value: answerData });
            } else {
              reportSection[i].values.push({ country, value: '-' });
            }
          } else {
            reportSection[i].values.push({ country, value: '-' });
          }
        });
        if (reportSection[i].groups && reportSection[i].groups.length) {
          parseReport(reportSection[i].groups);
        } else if (reportSection[i].questions && reportSection[i].questions.length) {
          reportSection[i].questions = parseQuestions(reportSection[i].questions); // eslint-disable-line no-param-reassign
        }
      }
      return reportSection;
    }

    const questions = parseReport([...reportData]);
    return questions;
  }
);

const getCountryList = (state) => state.countryProfile.mapCountries;
const getFilters = (state) => state.compare.filters;
export const getFilteredCountries = createSelector([getCountryList, getFilters], (countriesList, filters) => {
  const yearsArr = (filters || {}).years || [];
  const selectedYear = yearsArr.length ? yearsArr[0] : '';
  const scoreKey = `score${selectedYear}`;
  return countriesList.filter(el => {
    if (el['country-sectors']) {
      const sectorWithScore = el['country-sectors'].find(sector => {
        const scoreData = getScoreData(sector);
        return !!scoreData[scoreKey];
      });
      return !!sectorWithScore;
    }
    return false;
  });
});
const getCountrReportsLoadingData = (state) => state.compare.countriesReportsLoading;
export const getCountryReportsLoading = createSelector([getCountrReportsLoadingData],
   (countriesReportsLoading) => countriesReportsLoading['1'] || countriesReportsLoading['2'] || countriesReportsLoading['3']);
export const getCountriesDetail = createSelector(
    [getCompareCountries, getFilteredCountries],
    (compareCountries, countries) => compareCountries.map(iso => {
      if (!countries.length) return undefined;
      return {
        ...countries.find(c => c.iso === iso.split('_')[0]),
        iso
      };
    })
);




// WEBPACK FOOTER //
// ./app/selectors/compare.js